import { useState, useRef, useCallback } from 'react'
import { OrderHttpRepository } from 'orders/infrastructure/repositories/OrderHttpRepository'
import { GetOrdersSummaryUseCase } from 'orders/usecases/GetOrdersSummaryUseCase'
import { OrderAdapter, OrderSummaryView } from 'orders/infrastructure/adapters/OrderAdapter'

export function useOrderSummary() {
    const [summary, setSummary] = useState<OrderSummaryView | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const repositoryRef = useRef(new OrderHttpRepository())
    const useCaseRef = useRef(new GetOrdersSummaryUseCase(repositoryRef.current))

    const fetchSummary = useCallback(async () => {
        setLoading(true)
        setError(null)

        try {
            const result = await useCaseRef.current.execute()
            setSummary(OrderAdapter.toViewSummary(result))
        } catch (err) {
            setError('Error al cargar el resumen de órdenes')
            console.error('[useOrderSummary] Error fetching summary:', err)
        } finally {
            setLoading(false)
        }
    }, [])

    return {
        summary,
        loading,
        error,
        fetchSummary,
    }
}
